module.exports = __webpack_public_path__ + "img/6.728707f5.jpg";